import React from 'react';
import { useOCPP } from '../contexts/OCPPContext';
import ChargerCard from '../components/ChargerCard';
import StatsCard from '../components/StatsCard';

const Dashboard = () => {
  const { chargers, stats, loading, error, connectionStatus } = useOCPP();

  if (loading) {
    return <div className="loading">Loading charger data...</div>;
  }

  const chargerArray = Object.values(chargers);

  return (
    <div>
      <div className="dashboard-header">
        <h1>OCPP Server Dashboard</h1>
        <div style={{ fontSize: '0.9rem', color: '#666' }}>
          Last updated: {new Date().toLocaleTimeString()}
        </div>
      </div>

      {connectionStatus === 'disconnected' && (
        <div className="error">
          <strong>Warning:</strong> Real-time connection is disconnected.
          Data may not be current. Attempting to reconnect...
        </div>
      )}

      {error && connectionStatus !== 'connected' && (
        <div className="error">
          <strong>Error:</strong> {error}
        </div>
      )}

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '1rem', marginBottom: '2rem' }}>
        <StatsCard title="Total Chargers" value={stats.totalChargers} color="#007bff" />
        <StatsCard title="Online" value={stats.connectedChargers} color="#28a745" />
        <StatsCard title="Active Sessions" value={stats.activeTransactions} color="#fd7e14" />
        <StatsCard title="Total Power (kW)" value={stats.totalPower} color="#6f42c1" />
      </div>

      <div className="mb-4">
        <h2>Charging Stations</h2>
        {chargerArray.length === 0 ? (
          <div className="card text-center">
            <p>No charging stations found. Make sure the OCPP server is running and chargers are connected.</p>
          </div>
        ) : (
          <div className="charger-grid">
            {chargerArray.map(charger => (
              <ChargerCard key={charger.id} charger={charger} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Dashboard;